import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="system-notification-item"
// Individual notification banner controller
export default class extends Controller {
  static values = { id: Number }

  connect() {
    const key = `systemNotificationDismissed:${this.idValue}`
    const dismissed = localStorage.getItem(key)

    if (dismissed) {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    this.element.classList.remove('hidden')
  }

  hide() {
    this.element.classList.add('hidden')
  }

  dismiss() {
    const key = `systemNotificationDismissed:${this.idValue}`
    localStorage.setItem(key, new Date().toISOString())
    this.hide()
  }

  reopen() {
    const key = `systemNotificationDismissed:${this.idValue}`
    localStorage.removeItem(key)
    this.show()
  }

  toggle() {
    const isHidden = this.element.classList.contains('hidden')
    if (isHidden) {
      this.reopen()
    } else {
      this.dismiss()
    }
  }
}

